const selectSessionInvalidationWarning = authFailureReason => {
  if (!authFailureReason) {
    return null;
  }

  switch (authFailureReason) {
    case 'Session timed out':
      return 'INACTIVE_SESSION_TIMED_OUT';
      break;

    default:
      return 'SESSION_TIMED_OUT';
      break;
  }
};

export default selectSessionInvalidationWarning;